import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelText as _vModelText, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59f38daa"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "question-header question" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Frågor")
], -1))
const _hoisted_2 = {
  key: 0,
  class: "row"
}
const _hoisted_3 = { class: "col-sm-6" }
const _hoisted_4 = { class: "question" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Uppskov ")
const _hoisted_6 = {
  key: 1,
  class: "row"
}
const _hoisted_7 = { class: "col-sm-6" }
const _hoisted_8 = { class: "question" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Tjänstepension hos Skandia ")
const _hoisted_10 = {
  key: 2,
  class: "row"
}
const _hoisted_11 = { class: "col-sm-6" }
const _hoisted_12 = { class: "question" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Månatlig inkomst partner ")
const _hoisted_14 = {
  key: 3,
  class: "question"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Ska du äga bostaden själv?", -1))
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-4" }
const _hoisted_18 = ["checked"]
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Ja ")
const _hoisted_20 = { class: "col-4" }
const _hoisted_21 = ["checked"]
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Nej ")
const _hoisted_23 = { key: 4 }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "question-header" }, "Syfte med bolånet", -1))
const _hoisted_25 = {
  key: 0,
  class: "question"
}
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Köpa ny bostad")
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Köpa och sälja bostad")
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Köpa p.g.a. separation")
const _hoisted_29 = { key: 5 }
const _hoisted_30 = {
  key: 0,
  class: "row"
}
const _hoisted_31 = { class: "col-6" }
const _hoisted_32 = { class: "question" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode("Tillträdesdatum ")
const _hoisted_34 = { key: 6 }
const _hoisted_35 = { class: "row" }
const _hoisted_36 = {
  key: 0,
  class: "col-6"
}
const _hoisted_37 = { class: "question" }
const _hoisted_38 = /*#__PURE__*/_createTextVNode("Befintligt bolån ")
const _hoisted_39 = {
  key: 1,
  class: "col-6"
}
const _hoisted_40 = { class: "question" }
const _hoisted_41 = /*#__PURE__*/_createTextVNode("Överbryggningslån ")
const _hoisted_42 = { class: "question" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Har du signerat säljkontrakt?", -1))
const _hoisted_44 = {
  key: 0,
  class: "row"
}
const _hoisted_45 = { class: "col-4" }
const _hoisted_46 = ["checked"]
const _hoisted_47 = /*#__PURE__*/_createTextVNode(" Ja ")
const _hoisted_48 = { class: "col-4" }
const _hoisted_49 = ["checked"]
const _hoisted_50 = /*#__PURE__*/_createTextVNode(" Nej ")
const _hoisted_51 = {
  key: 0,
  class: "question row"
}
const _hoisted_52 = { class: "col-6" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Utgångspris", -1))
const _hoisted_54 = {
  key: 1,
  class: "question row"
}
const _hoisted_55 = { class: "col-6" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Slutpris", -1))
const _hoisted_57 = {
  key: 0,
  class: "question"
}
const _hoisted_58 = { class: "row question-header" }
const _hoisted_59 = { class: "col-6" }
const _hoisted_60 = /*#__PURE__*/_createTextVNode(" Kontantinsats ")
const _hoisted_61 = { class: "row" }
const _hoisted_62 = { class: "col-6" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Bostadsförsäljning", -1))
const _hoisted_64 = { class: "col-6" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Sparande", -1))
const _hoisted_66 = { class: "row" }
const _hoisted_67 = { class: "col-6" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Gåva", -1))
const _hoisted_69 = { class: "col-6" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Arv", -1))
const _hoisted_71 = { class: "row" }
const _hoisted_72 = { class: "col-6" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Lån", -1))
const _hoisted_74 = { class: "col-6" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Övrigt", -1))
const _hoisted_76 = { class: "question-header" }
const _hoisted_77 = /*#__PURE__*/_createTextVNode(" Belopp kvar att ange: ")
const _hoisted_78 = {
  key: 1,
  class: "question"
}
const _hoisted_79 = { class: "row" }
const _hoisted_80 = { class: "col-12" }
const _hoisted_81 = { class: "question-header" }
const _hoisted_82 = /*#__PURE__*/_createTextVNode(" Information om privatlån/krediter ")
const _hoisted_83 = { key: 0 }
const _hoisted_84 = { class: "row" }
const _hoisted_85 = { class: "col-6" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Amortering", -1))
const _hoisted_87 = { class: "col-6" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Räntesats", -1))
const _hoisted_89 = { class: "row" }
const _hoisted_90 = { class: "col-6" }
const _hoisted_91 = /*#__PURE__*/_createTextVNode("Andel av lån ")
const _hoisted_92 = {
  key: 2,
  class: "question"
}
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "question-header" }, "Bostäder som ska behållas", -1))
const _hoisted_94 = { key: 0 }
const _hoisted_95 = { key: 0 }
const _hoisted_96 = { class: "row" }
const _hoisted_97 = { class: "col-6" }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Bolån", -1))
const _hoisted_99 = { class: "col-6" }
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Räntesats", -1))
const _hoisted_101 = { class: "row" }
const _hoisted_102 = { class: "col-6" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Månadskostnad", -1))
const _hoisted_104 = { class: "col-6" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Amortering per månad", -1))
const _hoisted_106 = { class: "row" }
const _hoisted_107 = { class: "col-6" }
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Andel av bostad", -1))
const _hoisted_109 = {
  key: 3,
  class: "question"
}
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "question-header" }, "Information om din bostad", -1))
const _hoisted_111 = { class: "row" }
const _hoisted_112 = {
  key: 0,
  class: "col-6"
}
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Bolån", -1))
const _hoisted_114 = {
  key: 1,
  class: "col-6"
}
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Räntesats", -1))
const _hoisted_116 = { class: "row" }
const _hoisted_117 = {
  key: 0,
  class: "col-6"
}
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Andel av bostad", -1))
const _hoisted_119 = { class: "alert-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_Number = _resolveComponent("Number")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", null, [
      (_ctx.isRequired('propertyAmountFromPreviousSell'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("label", null, [
                  _hoisted_5,
                  _createVNode(_component_Tooltip, { title: "Uppskjuten skatt från tidigare bostadsförsäljningar." })
                ]),
                _createVNode(_component_Number, {
                  modelValue: _ctx.form.propertyAmountFromPreviousSell,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.propertyAmountFromPreviousSell) = $event)),
                  ref: "propertyAmountFromPreviousSell",
                  required: true
                }, null, 8, ["modelValue"])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isRequired('totalSavingsInSkandia'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("label", null, [
                  _hoisted_9,
                  _createVNode(_component_Tooltip, { title: "Om du har tjänstepension hos Skandia får du ytterliggare rabatt på din\n        bolåneränta." })
                ]),
                _createVNode(_component_Number, {
                  modelValue: _ctx.form.totalSavingsInSkandia,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.totalSavingsInSkandia) = $event)),
                  ref: "totalSavingsInSkandia",
                  required: true
                }, null, 8, ["modelValue"])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isRequired('partnerMonthlyIncome'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("label", null, [
                  _hoisted_13,
                  _createVNode(_component_Tooltip, { title: "Om du planerar att ta lånet ensam men har en partner behöver vi\n        information om dennas inkomst." })
                ]),
                _createVNode(_component_Number, {
                  modelValue: _ctx.form.partnerMonthlyIncome,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.partnerMonthlyIncome) = $event)),
                  ref: "partnerMonthlyIncome",
                  required: true
                }, null, 8, ["modelValue"])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isRequired('propertyHavingOtherOwner'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("input", {
                  onChange: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.form.propertyHavingOtherOwner = true), ["prevent"])),
                  type: "checkbox",
                  checked: _ctx.form.propertyHavingOtherOwner === true,
                  class: "bigger-checkbox"
                }, null, 40, _hoisted_18),
                _hoisted_19
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("input", {
                  onChange: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.form.propertyHavingOtherOwner = false), ["prevent"])),
                  type: "checkbox",
                  class: "bigger-checkbox",
                  checked: _ctx.form.propertyHavingOtherOwner === false
                }, null, 40, _hoisted_21),
                _hoisted_22
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isRequired('skandiaLoanPurpose'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _hoisted_24,
            (_ctx.isRequired('skandiaLoanPurpose'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _createElementVNode("div", null, [
                    _createElementVNode("label", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.skandiaLoanPurpose) = $event)),
                        value: 'Buy'
                      }, null, 512), [
                        [_vModelRadio, _ctx.form.skandiaLoanPurpose]
                      ]),
                      _hoisted_26
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("label", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.skandiaLoanPurpose) = $event)),
                        value: 'BuyAndSell'
                      }, null, 512), [
                        [_vModelRadio, _ctx.form.skandiaLoanPurpose]
                      ]),
                      _hoisted_27
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("label", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.skandiaLoanPurpose) = $event)),
                        value: 'BuyAndSplit'
                      }, null, 512), [
                        [_vModelRadio, _ctx.form.skandiaLoanPurpose]
                      ]),
                      _hoisted_28
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.form.skandiaLoanPurpose == 'Buy')
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
            (_ctx.isRequired('propertyBuyingDate'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("label", null, [
                        _hoisted_33,
                        _createVNode(_component_Tooltip, { title: "Ange dagen då du får tillträde till din nya bostad. Om tillträdesdagen inte är satt kan du ange en dag 3 månader fram i tiden." })
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        type: "date",
                        class: "picker input-container",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.propertyBuyingDate) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.form.propertyBuyingDate]
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.form.skandiaLoanPurpose == 'BuyAndSell')
        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_35, [
                (_ctx.isRequired('existingLoanAmount'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("label", null, [
                          _hoisted_38,
                          _createVNode(_component_Tooltip, { title: "Ange storleken på ditt befintliga bolån." })
                        ]),
                        _createVNode(_component_Number, {
                          modelValue: _ctx.form.existingLoanAmount,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.existingLoanAmount) = $event)),
                          ref: "existingLoanAmount",
                          required: true
                        }, null, 8, ["modelValue"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isRequired('bridgeLoanAmount'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("label", null, [
                          _hoisted_41,
                          _createVNode(_component_Tooltip, { title: "Ett överbryggningslån är ett tillfälligt lån för dig som ska köpa en bostad innan du säljer din befintliga. Ange beloppet du behöver låna." })
                        ]),
                        _createVNode(_component_Number, {
                          modelValue: _ctx.form.bridgeLoanAmount,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.bridgeLoanAmount) = $event)),
                          ref: "bridgeLoanAmount",
                          required: true
                        }, null, 8, ["modelValue"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_42, [
                _hoisted_43,
                (_ctx.isRequired('sellingContractSigned'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("input", {
                          onChange: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.form.sellingContractSigned = true), ["prevent"])),
                          type: "checkbox",
                          checked: _ctx.form.sellingContractSigned === true,
                          class: "bigger-checkbox"
                        }, null, 40, _hoisted_46),
                        _hoisted_47
                      ]),
                      _createElementVNode("div", _hoisted_48, [
                        _createElementVNode("input", {
                          onChange: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.form.sellingContractSigned = false), ["prevent"])),
                          type: "checkbox",
                          class: "bigger-checkbox",
                          checked: _ctx.form.sellingContractSigned === false
                        }, null, 40, _hoisted_49),
                        _hoisted_50
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.form.sellingContractSigned === false)
                ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                    _createElementVNode("div", _hoisted_52, [
                      _hoisted_53,
                      _createVNode(_component_Number, {
                        modelValue: _ctx.form.propertyStartingPrice,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.propertyStartingPrice) = $event)),
                        required: true
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.form.sellingContractSigned === true)
                ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                    _createElementVNode("div", _hoisted_55, [
                      _hoisted_56,
                      _createVNode(_component_Number, {
                        modelValue: _ctx.form.propertySellingPrice,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.propertySellingPrice) = $event)),
                        required: true
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        (_ctx.isRequired('downPaymentFrom'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("div", _hoisted_59, [
                  _hoisted_60,
                  _createVNode(_component_Tooltip, { title: "Enligt lag behöver vi och långivarna veta vart kontantinsatsen kommer från. Fyll i det nedan för snabbare hantering av ditt ärende." })
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_61, [
                  _createElementVNode("div", _hoisted_62, [
                    _hoisted_63,
                    _createVNode(_component_Number, {
                      modelValue: _ctx.form.downPaymentFromHomeSale,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.downPaymentFromHomeSale) = $event)),
                      ref: "downPaymentFromHomeSale"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_64, [
                    _hoisted_65,
                    _createVNode(_component_Number, {
                      modelValue: _ctx.form.downPaymentFromSavings,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.downPaymentFromSavings) = $event)),
                      ref: "downPaymentFromSavings"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_66, [
                  _createElementVNode("div", _hoisted_67, [
                    _hoisted_68,
                    _createVNode(_component_Number, {
                      modelValue: _ctx.form.downPaymentFromGift,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.downPaymentFromGift) = $event)),
                      ref: "downPaymentFromGift"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_69, [
                    _hoisted_70,
                    _createVNode(_component_Number, {
                      modelValue: _ctx.form.downPaymentFromHeritage,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.downPaymentFromHeritage) = $event)),
                      ref: "downPaymentFromHeritage"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_71, [
                  _createElementVNode("div", _hoisted_72, [
                    _hoisted_73,
                    _createVNode(_component_Number, {
                      modelValue: _ctx.form.downPaymentFromLoan,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.form.downPaymentFromLoan) = $event)),
                      ref: "downPaymentFromLoan"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_74, [
                    _hoisted_75,
                    _createVNode(_component_Number, {
                      modelValue: _ctx.form.downPaymentFromOther,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.form.downPaymentFromOther) = $event)),
                      ref: "downPaymentFromOther"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_76, [
                  _hoisted_77,
                  _createElementVNode("strong", null, _toDisplayString(_ctx.downPaymentToEnter.toLocaleString("se")) + " kr", 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isRequired('privateLoansDetails'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
              _createElementVNode("div", _hoisted_79, [
                _createElementVNode("div", _hoisted_80, [
                  _createElementVNode("div", _hoisted_81, [
                    _hoisted_82,
                    _createVNode(_component_Tooltip, { title: "Ange information om dina privatlån och krediter för smidigare hantering av ditt ärende." })
                  ])
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.privateLoans, (loan, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, [
                  (_ctx.form.privateLoans.length > 1)
                    ? (_openBlock(), _createElementBlock("strong", _hoisted_83, "Lån " + _toDisplayString(index + 1), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_84, [
                    _createElementVNode("div", _hoisted_85, [
                      _hoisted_86,
                      _createVNode(_component_Number, {
                        modelValue: _ctx.form.privateLoans[index].amortizationAmount,
                        "onUpdate:modelValue": ($event: any) => ((_ctx.form.privateLoans[index].amortizationAmount) = $event),
                        ref_for: true,
                        ref: 'amortizationAmount' + index,
                        required: true
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_87, [
                      _hoisted_88,
                      _createVNode(_component_Number, {
                        modelValue: _ctx.form.privateLoans[index].interestRate,
                        "onUpdate:modelValue": ($event: any) => ((_ctx.form.privateLoans[index].interestRate) = $event),
                        percent: true,
                        ref_for: true,
                        ref: 'interestRate' + _ctx.r,
                        required: true
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_89, [
                    _createElementVNode("div", _hoisted_90, [
                      _createElementVNode("label", null, [
                        _hoisted_91,
                        _createVNode(_component_Tooltip, { title: "Om du har lånet tillsammans med någon anger du 50%. Ifall du står på lånet själv anger du 100%" })
                      ]),
                      _createVNode(_component_Number, {
                        modelValue: _ctx.form.privateLoans[index].ownerShipShare,
                        "onUpdate:modelValue": ($event: any) => ((_ctx.form.privateLoans[index].ownerShipShare) = $event),
                        percent: true,
                        ref_for: true,
                        ref: 'ownerShipShare' + index,
                        required: true
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ])
                  ])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_ctx.isRequired('housingsDetails'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
              _hoisted_93,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.housings, (housing, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, [
                  (housing.keepCurrentHousing)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                        (_ctx.form.housings.length > 1)
                          ? (_openBlock(), _createElementBlock("strong", _hoisted_95, "Nuvarande bostad " + _toDisplayString(index + 1), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_96, [
                          _createElementVNode("div", _hoisted_97, [
                            _hoisted_98,
                            _createVNode(_component_Number, {
                              modelValue: _ctx.form.housings[index].amount,
                              "onUpdate:modelValue": ($event: any) => ((_ctx.form.housings[index].amount) = $event),
                              ref_for: true,
                              ref: 'housingAmount' + index,
                              required: true
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_99, [
                            _hoisted_100,
                            _createVNode(_component_Number, {
                              modelValue: _ctx.form.housings[index].interestRate,
                              "onUpdate:modelValue": ($event: any) => ((_ctx.form.housings[index].interestRate) = $event),
                              ref_for: true,
                              ref: 'housingInterestRate' + index,
                              percent: true,
                              required: true
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_101, [
                          _createElementVNode("div", _hoisted_102, [
                            _hoisted_103,
                            _createVNode(_component_Number, {
                              modelValue: _ctx.form.housings[index].monthlyCost,
                              "onUpdate:modelValue": ($event: any) => ((_ctx.form.housings[index].monthlyCost) = $event),
                              ref_for: true,
                              ref: 'housingMonthlyCost' + index,
                              required: true
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_104, [
                            _hoisted_105,
                            _createVNode(_component_Number, {
                              modelValue: _ctx.form.housings[index].amortizationAmount,
                              "onUpdate:modelValue": ($event: any) => ((_ctx.form.housings[index].amortizationAmount) = $event),
                              ref_for: true,
                              ref: 'housingOwnerShipShare' + index,
                              required: true
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_106, [
                          _createElementVNode("div", _hoisted_107, [
                            _hoisted_108,
                            _createVNode(_component_Number, {
                              modelValue: _ctx.form.housings[index].ownerShipShare,
                              "onUpdate:modelValue": ($event: any) => ((_ctx.form.housings[index].ownerShipShare) = $event),
                              ref_for: true,
                              ref: 'housingMonthlyCost' + index,
                              required: true,
                              percent: true
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (
            _ctx.isRequired('propertyAmortizationAmount') ||
            _ctx.isRequired('propertyInterestRate') ||
            _ctx.isRequired('propertyOwnerShipShare')
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
              _hoisted_110,
              _createElementVNode("div", _hoisted_111, [
                (_ctx.isRequired('propertyAmortizationAmount'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                      _hoisted_113,
                      _createVNode(_component_Number, {
                        ref: "propertyAmortizationAmount",
                        modelValue: _ctx.form.propertyAmortizationAmount,
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.form.propertyAmortizationAmount) = $event)),
                        required: true
                      }, null, 8, ["modelValue"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isRequired('propertyInterestRate'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_114, [
                      _hoisted_115,
                      _createVNode(_component_Number, {
                        ref: "propertyInterestRate",
                        modelValue: _ctx.form.propertyInterestRate,
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.form.propertyInterestRate) = $event)),
                        percent: true,
                        required: true
                      }, null, 8, ["modelValue"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_116, [
                (_ctx.isRequired('propertyOwnerShipShare'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_117, [
                      _hoisted_118,
                      _createVNode(_component_Number, {
                        ref: "propertyOwnerShipShare",
                        modelValue: _ctx.form.propertyOwnerShipShare,
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.form.propertyOwnerShipShare) = $event)),
                        percent: true,
                        required: true
                      }, null, 8, ["modelValue"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("button", {
      onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args))),
      class: "col-12 btn primary-button-send"
    }, " Spara "),
    _withDirectives(_createElementVNode("div", _hoisted_119, " Något är fel i ansökan, se ovan. ", 512), [
      [_vShow, _ctx.submitted && !_ctx.valid]
    ])
  ]))
}